import {isOnSmallScreen} from '../is'

/**
 * Argent.js
 *
 * JavaScript for the Argent Theme
 */

const $ = window.jQuery

/**
 * initSlickSlideshows
 */
function initSlickSlideshows() {
	const $slideshows = $('[data-slick-slideshow]')

	$slideshows.each(function () {
		const $_slideshow = $(this)
		const defaultSettings = {
			accessibility: true,
			infinite: true,
			swipe: true
		}

		const userSettings = $_slideshow.data('slick')
		const settings = {...defaultSettings, ...userSettings}

		$_slideshow.slick(settings)
	})
}

initSlickSlideshows()

/**
 * reinitSlickSlideshows
 */
function reinitSlickSlideshows() {
	const $slideshows = $('[data-slick-slideshow]')

	$slideshows.each(function () {
		const $_slideshow = $(this)
		$_slideshow.slick('unslick')

		const defaultSettings = {
			accessibility: true,
			infinite: true,
			swipe: true
		}

		const userSettings = $_slideshow.data('slick')
		const settings = {...defaultSettings, ...userSettings}

		$_slideshow.slick(settings)
	})
}

/**
 * initCollectionCtas
 */
function initCollectionCtas() {
	const $collectionCtas = $('#shopify-section-collections__content--all')
	const $collectionsContent = $('.collections-content')

	$collectionsContent.append($collectionCtas.html())
	$collectionCtas.hide()
}

initCollectionCtas()

/**
 * initFaqs
 */
function initFaqs() {
	if (isOnSmallScreen()) {
		const masonryContainer = $('[data-masonry]')[0]
		const $faqCategories = $('.faq-content--category')

		$faqCategories.each(function () {
			const $category = $(this)
			const $categoryTitle = $category.children('.faq-content--category-title')
			const $categoryContent = $category.children('.faq-content--category-questions')
			const $icon = $category.children('.faq-content--category-title__icon')

			$categoryTitle.on('click touch', function (e) {
				$category.toggleClass('open')
				$categoryContent.toggle()
				$icon.toggleClass('closed')

				const msnry = Masonry.data(masonryContainer)
				if (msnry) msnry.destroy()
			})
		})
	}
}

initFaqs()

/**
 * initCollapseContainers
 */
function initCollapseContainers() {
	const masonryContainer = $('[data-masonry]')[0]
	const $collapseCategories = $('.collapse-container')

	$collapseCategories.each(function () {
		const $category = $(this)
		const $categoryTitle = $category.children('.collapse-heading')
		const $categoryContent = $category.children('.collapse-content')
		const $icon = $category.children('.collapse-icon')

		$categoryTitle.on('click touch', function (e) {
			if ($category.hasClass('open')) {
				$category.removeClass('open')
				$category.addClass('closed')
			} else if ($category.hasClass('closed')) {
				$category.removeClass('closed')
				$category.addClass('open')
			}
			$icon.toggleClass('closed')

			const msnry = Masonry.data(masonryContainer)
			if (msnry) msnry.destroy()
		})
	})
}

initCollapseContainers()

/**
 * destroyMasonryOnCollapseClick
 */
function destroyMasonryOnCollapseClick() {
	const masonryContainer = $('[data-masonry]')[0]
	const $collapseCategories = $('[data-toggle="collapse"]')

	$collapseCategories.each(function () {
		const $category = $(this)

		$category.on('click touch', function (e) {
			const msnry = Masonry.data(masonryContainer)
			if (msnry) msnry.destroy()
		})
	})
}

destroyMasonryOnCollapseClick()

/**
 * set first style guide laydown as active on page load
 */
function initStyleGuideTabs() {
	// add/remove 'active' class to 'li' elements when child 'a' is 'active'
	$('#styleGuideTabs .active').parent('li').addClass('active')
	$('#styleGuideTabs').on('shown.bs.tab', function () {
		$('#styleGuideTabs li').removeClass('active')
		$('#styleGuideTabs .active').parent('li').addClass('active')
		reinitSlickSlideshows()
	})
}

initStyleGuideTabs()